









































































import { Component, Prop, Vue } from "vue-property-decorator";
import MonitoringKritisIgdIntervensiDialog from "./MonitoringKritisIgdIntervensiDialog.vue";
import MonitoringKritisIgdMedikasiDialog from "./MonitoringKritisIgdMedikasiDialog.vue";
import MonitoringKritisIgdSvc from "@/services/MonitoringKritisIgdService";
import { appModule } from "@/store/modules/app";
import moment from "moment";

@Component({
  components: { MonitoringKritisIgdIntervensiDialog, MonitoringKritisIgdMedikasiDialog }
})
export default class MonitoringKritisIgdActionTimeline extends Vue {
  @Prop() monitoring!: any;
  @Prop({ default: false }) readonly!: boolean;

  showIntervensiDialog = false;
  showMedikasiDialog = false;
  editingIntervensi: any = null;
  editingMedikasi: any = null;

  get timelineItems(): any[] {
    const intervensis = (this.monitoring?.intervensis || []).map((i: any) => ({ ...i, _type: "intervensi" }));
    const medikasis = (this.monitoring?.medikasis || []).map((m: any) => ({ ...m, _type: "medikasi" }));
    return [...intervensis, ...medikasis].sort(
      (a, b) => new Date(a.waktu).getTime() - new Date(b.waktu).getTime()
    );
  }

  formatTime(waktu: string) {
    return waktu ? moment(waktu).format("HH:mm") : "-";
  }

  tambahIntervensi() {
    this.editingIntervensi = null;
    this.showIntervensiDialog = true;
  }

  tambahMedikasi() {
    this.editingMedikasi = null;
    this.showMedikasiDialog = true;
  }

  editItem(item: any) {
    if (item._type === "intervensi") {
      this.editingIntervensi = item;
      this.showIntervensiDialog = true;
    } else {
      this.editingMedikasi = item;
      this.showMedikasiDialog = true;
    }
  }

  async deleteItem(item: any) {
    const label = item._type === "intervensi" ? "intervensi" : "medikasi";
    if (!confirm(`Hapus ${label} ini?`)) return;
    try {
      let resp;
      if (item._type === "intervensi") {
        resp = await MonitoringKritisIgdSvc.deleteIntervensi(this.monitoring.id, item.id);
      } else {
        resp = await MonitoringKritisIgdSvc.deleteMedikasi(this.monitoring.id, item.id);
      }
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay(`${label} dihapus`);
        this.$emit("saved");
      }
    } catch { /* handled */ }
  }

  onSaved() {
    this.showIntervensiDialog = false;
    this.showMedikasiDialog = false;
    this.editingIntervensi = null;
    this.editingMedikasi = null;
    this.$emit("saved");
  }
}
